<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row my-5">
    <div class="col-md-6 col-12">
      <div class="selectTopic text-center" routerLink="payment-management-goverment" [queryParams]="{ACCOUNTING_ID: '038-308312-5'}">
        <img src="../../../assets/other/building.png" class="topicImg">
      </div>
      <h2 class="textTopic text-center"><b>บัญชีราชการ</b></h2>
    </div>
    <div class="col-md-6 col-12">
      <div class="selectTopic text-center" routerLink="payment-management-goverment" [queryParams]="{ACCOUNTING_ID: '138-177454-2'}">
        <img src="../../../assets/other/buildings.png" class="topicImg">
      </div>
      <h2 class="textTopic text-center"><b>บัญชีบริษัท</b></h2>
    </div>
  </div>
</div>